/**
 * Loads TalkJS libraries and session manager dynamically when needed
 */
export const TalkJsManager = async () => (await import('./talkjs-manager')).default;
